import React from 'react';

import { useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { AtlassianNavigation, ProductHome } from '@atlaskit/atlassian-navigation';
import { AtlassianIcon } from '@atlaskit/logo';
import { getHistory } from '@atlassian/ptc-common';

import { AddPeopleButton } from './AddPeopleButton';
import AtlassianSwitcherItem from './AtlassianSwitcher';
import { CreateTeamButton } from './CreateTeamButton';
import { messages } from './messages';
import { TeamsAppLogo } from './TeamsAppLogo';
import UserMenu from './UserMenu';

const isWithMetaKey = (event: React.MouseEvent): boolean =>
	!!(event && (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey));

const DirectoryHome = () => {
	const intl = useIntl();
	const navigate = (event: React.MouseEvent) => {
		const withMetaKey = isWithMetaKey(event);

		if (!withMetaKey) {
			event.preventDefault();
		}

		getHistory().push('/search');
	};

	return (
		<ProductHome
			icon={AtlassianIcon}
			logo={TeamsAppLogo}
			href="/search"
			onClick={navigate}
			aria-label={intl.formatMessage(messages.teamsLabel)}
		/>
	);
};

export const Navigation = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<AtlassianNavigation
			label={intl.formatMessage(messages.teamsLabel)}
			renderAppSwitcher={AtlassianSwitcherItem}
			renderProfile={UserMenu}
			primaryItems={[<CreateTeamButton key="createPeople" />, <AddPeopleButton key="addPeople" />]}
			renderProductHome={DirectoryHome}
		/>
	);
};
